import React from 'react';
import './TalTable.css'

const TalTable = () => {
    return (
        <table class="">
            <thead className='text-center'>
                <tr>
                    <span className='p-3'>ত্রিতাল</span>
                </tr>
            </thead>
            <thead>
                <tr>
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th>5</th>
                    <th>6</th>
                    <th>7</th>
                    <th>8</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>ধা</td>
                    <td>ধিন</td>
                    <td>ধিন</td>
                    <td>ধা</td>
                    <td>ধা</td>
                    <td>ধিন</td>
                    <td>ধিন</td>
                    <td>ধা</td>
                </tr>
                <tr>
                    <th>9</th>
                    <th>10</th>
                    <th>11</th>
                    <th>12</th>
                    <th>13</th>
                    <th>14</th>
                    <th>15</th>
                    <th>16</th>
                </tr>
                <tr>

                    <td>না</td>
                    <td>তিন</td>
                    <td>তিন</td>
                    <td>তা</td>
                    <td>তেটে</td>
                    <td>ধিন</td>
                    <td>ধিন</td>
                    <td>ধা</td>
                </tr>
            </tbody>
        </table>
    );
};

export default TalTable;